export default "__VITE_ASSET__BF8OLoZh__"